import React, { useEffect } from 'react';
import {
  ProductInformationProps,
  StyledTextField,
} from '../productInformation';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useQuery } from 'react-query';
import { client } from 'src/utils/api-client';
import { useTranslation } from 'react-i18next';

export default function BasicInfo({
  setValues,
  values,
}: ProductInformationProps) {
  const { t } = useTranslation('lca', { keyPrefix: 'basicInfo' });

  const { data: ecoinventVersions } = useQuery('getEcoinventVersions', () => {
    return client.get<string[]>('/web/lca/ecoinvent-versions');
  });
  const isNewProduct = values.id === 0;

  // set default ecoinvent version to the latest
  useEffect(() => {
    if (isNewProduct && ecoinventVersions?.data) {
      setValues({
        ...values,
        ecoinvent_version: ecoinventVersions.data.at(-1),
      });
    }
  }, [ecoinventVersions, values.id, setValues]);

  const handleName = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setValues({ ...values, name: e.target.value });
  };
  const handleDesc = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setValues({ ...values, description: e.target.value });
  };
  const handleEcoinventVersion = (e: SelectChangeEvent) => {
    setValues({ ...values, ecoinvent_version: e.target.value });
  };

  return (
    <div
      style={{
        display: 'flex',
        gap: '24px',
        flexDirection: 'column',
      }}
    >
      <StyledTextField
        fullWidth
        label={t('productName')}
        name="name"
        value={values.name}
        onChange={handleName}
        required
      />
      <StyledTextField
        fullWidth
        label={t('productDescription')}
        name="description"
        value={values.description}
        onChange={handleDesc}
        multiline
        rows={3}
        required
      />

      <FormControl fullWidth>
        <InputLabel>{t('ecoinventVersion')}</InputLabel>
        <Select
          value={values.ecoinvent_version ?? ''}
          label={t('ecoinventVersion')}
          onChange={handleEcoinventVersion}
          disabled={!isNewProduct}
        >
          {ecoinventVersions?.data.map((version) => (
            <MenuItem key={version} value={version}>
              {version}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
